import PropTypes from 'prop-types';
import React from 'react';
import { LAYOUT_CARD_PROFILE, SECTION_CATEGORY } from '@wix/communities-blog-client-common';
import CommentSearchListItem from '../../../app/components/comment-search-list-item';
import styles from './comment-list.scss';

const CommentList = ({ comments, onCommentLikeClick, onPostLikeClick, showLikeButton }) => (
  <div>
    {comments.map((comment) => (
      <div key={`comment-${comment._id}`} className={styles.item}>
        <CommentSearchListItem
          section={SECTION_CATEGORY}
          layoutType={LAYOUT_CARD_PROFILE}
          type="profile"
          comment={comment}
          onPostLikeClick={onPostLikeClick}
          onLikeClick={onCommentLikeClick}
          showLikeButton={showLikeButton}
        />
      </div>
    ))}
  </div>
);

CommentList.propTypes = {
  comments: PropTypes.arrayOf(PropTypes.object),
  onCommentLikeClick: PropTypes.func.isRequired,
  onPostLikeClick: PropTypes.func.isRequired,
  showLikeButton: PropTypes.bool.isRequired,
};

export default CommentList;
